import {
  GET_ORGANIZATION_USERS_REQUEST,
  GET_ORGANIZATION_USERS_SUCCESS,
  GET_ORGANIZATION_USERS_ERROR,
  ACCEPT_USER_REQUEST,
  ACCEPT_USER_SUCCESS,
  ACCEPT_USER_ERROR,
  REJECT_USER_REQUEST,
  REJECT_USER_SUCCESS,
  REJECT_USER_ERROR,
  UNLOCK_USER_REQUEST,
  UNLOCK_USER_SUCCESS,
  UNLOCK_USER_ERROR,
  INVITE_USER_REQUEST,
  INVITE_USER_SUCCESS,
  INVITE_USER_ERROR,
  UPDATE_USER_ROLE_REQUEST,
  UPDATE_USER_ROLE_SUCCESS,
  SCHEDULE_UPDATE_USER_ROLE,
  UPDATE_USER_ROLE_ERROR,
  UPDATE_USER_STATUS_REQUEST,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER_STATUS_ERROR
} from "../actions/organization_users";
import {
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR
} from "../actions/session";

import { appendOrReplaceEntity, replaceEntity, removeEntity } from "@utils/reducers";

const defaultState = {
  isFetching: false,
  fetchedAt: null,
  error: null,
  data: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_ORGANIZATION_USERS_REQUEST: {
      return {
        ...state,
        isFetching: true
      };
    }

    case GET_ORGANIZATION_USERS_SUCCESS: {
      const { data: users } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: users
      };
    }

    case GET_ORGANIZATION_USERS_ERROR: {
      const { error } = action;

      return {
        ...state,
        isFetching: false,
        error
      };
    }

    case ACCEPT_USER_REQUEST:
    case REJECT_USER_REQUEST:
    case UPDATE_USER_REQUEST:
    case UPDATE_USER_STATUS_REQUEST: {
      return {
        ...state,
        isFetching: true
      };
    }

    case ACCEPT_USER_SUCCESS:
    case UPDATE_USER_SUCCESS:
    case UPDATE_USER_STATUS_SUCCESS: {
      const { user: newUser } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: replaceEntity(state.data, newUser)
      };
    }

    case REJECT_USER_SUCCESS: {
      const { user: newUser } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: removeEntity(state.data, newUser)
      };
    }

    case ACCEPT_USER_ERROR:
    case REJECT_USER_ERROR:
    case UPDATE_USER_ERROR:
    case UPDATE_USER_STATUS_ERROR: {
      const { error } = action;

      return {
        ...state,
        isFetching: false,
        error
      };
    }

    case UNLOCK_USER_REQUEST:
    case INVITE_USER_REQUEST:
    case UPDATE_USER_ROLE_REQUEST: {
      return {
        ...state,
        isFetching: true
      };
    }

    case UNLOCK_USER_SUCCESS:
    case UPDATE_USER_ROLE_SUCCESS: {
      const { data: newUser } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: replaceEntity(state.data, newUser)
      };
    }

    case INVITE_USER_SUCCESS: {
      const { data: newUser } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: appendOrReplaceEntity(state.data, newUser)
      };
    }

    case UNLOCK_USER_ERROR:
    case INVITE_USER_ERROR:
    case UPDATE_USER_ROLE_ERROR: {
      const { error } = action;

      return {
        ...state,
        isFetching: false,
        error
      };
    }

    case SCHEDULE_UPDATE_USER_ROLE: {
      const { userId, scheduledRoleId } = action;

      const user = state.data && state.data.find(user => user.id === userId);

      if (!user) {
        return state;
      }

      const newUser = {
        ...user,
        scheduledRoleId
      };

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: replaceEntity(state.data, newUser)
      };
    }

    default: return state;
  }
};
